/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Vlt-icon-file-pdf': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M1.9 16.3h1.5c1.3 0 2.1-.9 2.1-2.1 0-1.2-.7-2-2-2H.8v6.3h1.1v-2.2zm0-3h1.4c.6 0 1 .4 1 1s-.4 1.1-1.1 1.1H1.9v-2.1zM11.5 15.3c0-1.9-.9-3.1-2.6-3.1H6.7v6.3h2.2c1.8 0 2.6-1.3 2.6-3.2zm-2.7 2.1h-1v-4.2h1c1.1 0 1.6.7 1.6 2.1 0 1.4-.5 2.1-1.6 2.1zM17.2 13.3v-1.1h-4.3v6.3H14v-2.6h3v-1h-3v-1.6z"/><path pid="1" d="M22.3 7.7L14.8.2c-.2-.1-.4-.2-.6-.2h-12c-.4 0-.7.3-.7.8V10H3V1.5h10.5v6.8c0 .4.3.8.8.8H21v13.5H3V21H1.5v2.2c0 .4.3.8.8.8h19.5c.4 0 .8-.3.8-.8v-15c-.1-.1-.2-.3-.3-.5zM15 7.5V2.6l4.9 4.9H15z"/>'
  }
})
